import { make } from 'vuex-pathify'
import dottie from 'dottie'
import { api } from '@/api'

const state = {
  zips: [],
  distance: 10000
}

const getters = {
  ...make.getters(state),
  zipsList(state) {
    return state.zips.map(z => {
      return z.zip
    })
  }
}

const mutations = {
  ...make.mutations(state)
}

const actions = {
  async near({ commit, state }, payload) {
    try {
      const zip = dottie.get(payload, 'zip', false)
      if (!zip) commit('SET_ZIPS', [])
      const response = await api.get(`/zips/near/${zip}/${state.distance}`)
      const zips = dottie.get(response, 'data.zips', [])
      commit('SET_ZIPS', zips)
    } catch (e) {
      commit('SET_ZIPS', [])
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
